module.exports = __webpack_public_path__ + "img/806f297.jpg";